export default __webpack_public_path__ + "static/media/fe120361035fb97ceabbdf72248fa2d2.svg";